import { useForm, Head, usePage } from '@inertiajs/react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Button } from '@/components/ui/button'
import { Wallet } from 'lucide-react'
import type { Flash } from '@/types'

export default function Login() {
  const { flash } = usePage<{ flash: Flash }>().props
  const { data, setData, post, processing } = useForm({ email: '' })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    post('/login')
  }

  return (
    <>
      <Head title="Login" />
      <div className="flex min-h-screen items-center justify-center bg-background px-4">
        <Card className="w-full max-w-sm">
          <CardHeader className="text-center">
            <div className="mx-auto mb-2 flex size-10 items-center justify-center rounded-lg bg-primary/15">
              <Wallet className="size-5 text-primary" />
            </div>
            <CardTitle className="text-xl">Open Tab</CardTitle>
            <CardDescription>Enter your email to receive a login link</CardDescription>
          </CardHeader>
          <CardContent>
            {flash?.notice && (
              <div className="mb-4 rounded-md border border-positive/20 bg-positive/10 px-3 py-2 text-sm text-positive">
                {flash.notice}
              </div>
            )}
            {flash?.alert && (
              <div className="mb-4 rounded-md border border-destructive/20 bg-destructive/10 px-3 py-2 text-sm text-destructive">
                {flash.alert}
              </div>
            )}
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="email">Email</Label>
                <Input
                  id="email"
                  type="email"
                  placeholder="you@example.com"
                  value={data.email}
                  onChange={(e) => setData('email', e.target.value)}
                  required
                  autoFocus
                />
              </div>
              <Button type="submit" className="w-full" disabled={processing}>
                {processing ? 'Sending...' : 'Send login link'}
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </>
  )
}
